import { render, staticRenderFns } from "./SimClassCard.vue?vue&type=template&id=6e228eca&scoped=true"
import script from "./SimClassCard.vue?vue&type=script&lang=js"
export * from "./SimClassCard.vue?vue&type=script&lang=js"
import style0 from "./SimClassCard.vue?vue&type=style&index=0&id=6e228eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e228eca",
  null
  
)

export default component.exports